import { render, staticRenderFns } from "./templateBtn.vue?vue&type=template&id=6fa9c865"
import script from "./templateBtn.vue?vue&type=script&lang=js"
export * from "./templateBtn.vue?vue&type=script&lang=js"
import style0 from "./templateBtn.vue?vue&type=style&index=0&id=6fa9c865&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports